<template>
  <span>
    <ProgressCell
      icon="images"
      :isLoading="isUploading"
      :theme="coverImageTheme"
      @click="openImageModal" />
    <ModalImageSelect
      v-if="doShowModal"
      :article="article"
      :fileId="article.imageFileId"
      :isUploading.sync="isUploading"
      type="ARTICLE_HERO_IMAGE"
      @close="doShowModal = false"
      @update:fields="$up('fields', $event)" />
  </span>
</template>

<script>
import ModalImageSelect from '@forms/ModalImageSelect'
import ProgressCell from './ProgressCell'

export default {
  components: {
    ModalImageSelect,
    ProgressCell,
  },
  props: {
    article: Object,
  },
  data() {
    return {
      doShowModal: false,
      isUploading: false,
    }
  },
  computed: {
    coverImageTheme() {
      return this.article.imageFileId
        ? 'success'
        : 'neutral'
    },
  },
  methods: {
    openImageModal() {
      this.doShowModal = true
    },
  },
}
</script>

<style lang="scss">
.MetaProgresss {
}
</style>

<i18n>
{
  "en": {
    "image": "Image"
  }
}
</i18n>
